import Detail1 from 'images/games/bingo-clash/detail1.png'
import Detail2 from 'images/games/bingo-clash/detail2.png'
import Detail3 from 'images/games/bingo-clash/detail3.png'
import Footer from 'images/games/bingo-clash/footer.png'
import Icon from 'images/games/bingo-clash/icon.png'
import Swiper1 from 'images/games/bingo-clash/swiper1.webp'
import Swiper2 from 'images/games/bingo-clash/swiper2.webp'
import Swiper3 from 'images/games/bingo-clash/swiper3.webp'
import Swiper4 from 'images/games/bingo-clash/swiper4.webp'
import Swiper5 from 'images/games/bingo-clash/swiper5.webp'
import Swiper6 from 'images/games/bingo-clash/swiper6.webp'
import { GamesLink } from '../../components'
import { BingoClashEntity } from './entity'
import { TemplatePageProps } from './types'

export const BingoClashDetail: TemplatePageProps = {
  entity: {
    ...BingoClashEntity,
    logo: Icon,
    title: (
      <>
        <strong>Bingo Clash: Online Bingo for Cash</strong>
      </>
    ),
    description: (
      <>
        Experience the thrill of real-money bingo with Bingo Clash—a fast-paced <strong>bingo cash app</strong> that{' '}
        blends <strong>classic bingo</strong> fun with exciting cash rewards! Play anytime, anywhere, and enjoy nonstop
        action with every round! Available on Apple Store, Galaxy Store, and as an APK. Download Bingo Clash now and
        start winning real cash!
      </>
    ),
  },
  media: {
    facebook: 'https://www.facebook.com/BingoClashOfficial',
    instagram: 'https://www.instagram.com/bingoclashofficial/',
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
  ],
  content: [
    {
      title: 'How to Play Bingo Clash: Unlock Fun and Rewards',
      description: (
        <>
          Bingo Clash gives <strong>classic bingo</strong> a thrilling upgrade with fast-paced, skill-based gameplay! As
          numbers are called, tap (&#34;daub&#34;) the matching ones on your card to earn points and charge power-ups.
          Use <strong>Gimme More (G)</strong> to pick the next number, use <strong>Daub It (Diamond)</strong> as a wild
          to daub any number, or use <strong>x2</strong> to double your points! You can only hold two power-ups at a
          time, so using them wisely and quickly is key. Score multiple bingos and smartly use your boosts to stay ahead
          of your opponents.
        </>
      ),
      image: Detail1,
    },
    {
      title: 'Turn Your Bingo Skills Into Bingo Cash',
      description: (
        <>
          In Bingo Clash, you&#39;ll compete in fast-paced matches where every player receives the same card and
          numbers, keeping the game fair and focused on your speed, accuracy, and strategy. Tap numbers fast and daub
          powerups wisely to outscore your opponents! Whether you’re playing for fun or going for cash prizes, each
          round is a battle of skill. Join multiplayer cash tournaments and weekly events to climb the leaderboard. No
          luck, just skill — this <strong>bingo app</strong> keeps the thrill going!{' '}
        </>
      ),
      image: Detail2,
    },
    {
      title: 'Fast-Paced Bingo for Fast and Easy Withdrawals',
      description: (
        <>
          With Bingo Clash, the excitement doesn’t stop when the game ends! Here, you can cash out your winnings quickly
          and securely. Thanks to trusted withdrawal options like PayPal, collecting your real money rewards is simple
          and hassle-free. Bingo Clash ensures a safe and smooth payout process, so you can focus on playing and earning
          more! Deposits are just as easy, with multiple payment methods supported, including PayPal, Venmo, Apple Pay,
          Visa, Mastercard, Amex, and Discover. Whether you&#39;re making your first deposit or cashing out your latest
          win, Bingo Clash offers a seamless experience from start to finish.
        </>
      ),
      image: Detail3,
    },
    {
      title: 'Play, Compete, Win Now!',
      description: (
        <>
          Bingo Clash brings together competitive excitement and real cash rewards in one thrilling{' '}
          <strong>bingo for cash</strong> app—but that’s just the beginning. If you enjoy the rush of skill-based bingo,
          explore more exciting <GamesLink strong>skill games</GamesLink> from Avia like Bingo Tour and Bingo Bliss.
          Want to switch it up? Try your hand at Solitaire Clash, line up shots in 8 Ball Strike, pop your way to the
          top in Bubble Buzz, or test your puzzle skills in Blockolot. Each game is designed to match you with players
          of similar skill and give you opportunities to win real money.
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
}
